export default __webpack_public_path__ + "static/404-img-new-6386c638e8d26c9bf92c5a9439478777.png";